import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// This is the main React entry file.
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
